import { themeV2 } from '@features/executive-report/domain/theme-v2';
import { slideMasters } from '@features/executive-report/utils/slide-masters';
import { Slide, TextProps, ZERO_WIDTH_SPACE } from '@features/powerpoint';
import { formatters } from '@utils/formattersV2';
import { parseReportDateToLocaleFormat } from '@utils/dates';

const getCardTextOptions = (): NonNullable<TextProps['options']> => ({
  valign: 'top',
  fontSize: 12,
  paraSpaceBefore: 12,
  shadow: { type: 'outer', opacity: 0.09, blur: 4, angle: 90, offset: 2 },
  fill: { type: 'solid', color: themeV2.colors.white },
});

type CampaignSummaryGiroasSlideProps = {
  flightDates: [string, string];
  campaignBudget: number;
  impressions: number;
  uniqueUsers: number;
};

export const campaignSummaryGiroasSlide = (
  props: CampaignSummaryGiroasSlideProps
): Slide => {
  const { flightDates, campaignBudget, impressions, uniqueUsers } = props;
  return {
    slideMaster: slideMasters.light,
    color: themeV2.colors.metricBlue,
    texts: [
      {
        text: 'Campaign Summary',
        options: {
          fontSize: 36,
          bold: true,
          h: 0.75,
          w: 12.67,
          x: 0.33,
          y: 0.25,
        },
      },
      {
        text: [
          {
            text: 'CAMPAIGN OBJECTIVE: ',
            options: {
              color: themeV2.colors.inmarketGreen,
            },
          },
          {
            text: 'Drive sales and iROAS',
          },
        ],
        options: {
          bold: true,
          h: 0.4,
          w: 10,
          x: 0.33,
          y: 1.17,
        },
      },
      {
        text: [
          {
            text: 'CAMPAIGN DETAILS',
            options: {
              color: themeV2.colors.inmarketGreen,
              bold: true,
              breakLine: true,
            },
          },
          {
            text: `Flight Dates: ${parseReportDateToLocaleFormat(flightDates[0])} - ${parseReportDateToLocaleFormat(flightDates[1])}`,
            options: { breakLine: true },
          },
          {
            text: `Campaign Budget: ${formatters.currency(campaignBudget, { full: true, decimals: 0 })}`,
            options: { breakLine: true },
          },
          {
            text: `Total Impressions: ${formatters.impressions(impressions, { full: true })}`,
            options: { breakLine: true },
          },
          {
            text: `Unique Users Reached: ${formatters.number(uniqueUsers, { full: true })}`,
            options: { breakLine: true },
          },
        ],
        options: {
          ...getCardTextOptions(),
          h: 2.04,
          w: 4.7,
          x: 0.33,
          y: 1.57,
        },
      },
      {
        text: [
          {
            text: 'LOCATION TARGETING',
            options: {
              color: themeV2.colors.inmarketGreen,
              bold: true,
              breakLine: true,
            },
          },
          {
            text: ZERO_WIDTH_SPACE,
            options: { breakLine: true },
          },
        ],
        options: {
          ...getCardTextOptions(),
          h: 2.04,
          w: 4.7,
          x: 5.13,
          y: 1.57,
        },
      },
      {
        text: [
          {
            text: 'CAMPAIGN PARAMETERS',
            options: {
              color: themeV2.colors.inmarketGreen,
              bold: true,
              breakLine: true,
            },
          },
          {
            text: ZERO_WIDTH_SPACE,
            options: { breakLine: true },
          },
        ],
        options: {
          ...getCardTextOptions(),
          h: 3.17,
          w: 4.7,
          x: 0.33,
          y: 3.73,
        },
      },
      {
        text: [
          {
            text: 'AUDIENCE TARGETING',
            options: {
              fontSize: 14,
              bold: true,
              color: themeV2.colors.inmarketGreen,
              breakLine: true,
            },
          },
          {
            text: ZERO_WIDTH_SPACE,
            options: { fontSize: 9.5 },
          },
        ],
        options: {
          ...getCardTextOptions(),
          h: 3.17,
          w: 4.7,
          x: 5.13,
          y: 3.73,
        },
      },
      {
        text: [
          {
            text: ZERO_WIDTH_SPACE,
            options: { breakLine: true },
          },
          {
            text: 'Creatives',
          },
        ],
        options: {
          ...getCardTextOptions(),
          bold: true,
          align: 'center',
          h: 5.33,
          w: 3.08,
          x: 9.94,
          y: 1.57,
        },
      },
    ],
  };
};
